export const ROOM_LIMIT = 25;

export const createInitialRoomState = () => ({
  Tab: "",
  RoomId: "",
  Name: "",
  Users: [],
  Customers: [],
});

export const fallbackRoomsQuery = () => ({
  data: null,
  isLoading: false,
  isError: false,
  error: null,
  refetch: async () => ({}),
  isUninitialized: true,
});

export const resolveUnreadPayload = (payload) => {
  if (!payload) return null;
  if (Array.isArray(payload?.data?.results)) return payload.data.results;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload)) return payload;
  if (payload?.data) return payload.data;
  return payload;
};

export const resolveRoomsPayload = (payload) => {
  if (!payload) return null;
  if (Array.isArray(payload?.results)) return payload;
  if (Array.isArray(payload?.data?.results)) return payload.data;
  return null;
};

export const sortRoomsByActivity = (rooms = []) => {
  return [...rooms].sort((a, b) => {
    const unreadA = (a?.UnreadCount || 0) > 0 ? 1 : 0;
    const unreadB = (b?.UnreadCount || 0) > 0 ? 1 : 0;
    if (unreadA !== unreadB) return unreadB - unreadA;
    const timestampA = new Date(
      a?.LastMessageAt ||
        a?.LastMessage?.MessageCreatedAt ||
        a?.RoomUpdatedAt ||
        a?.RoomCreatedAt ||
        0
    ).getTime();
    const timestampB = new Date(
      b?.LastMessageAt ||
        b?.LastMessage?.MessageCreatedAt ||
        b?.RoomUpdatedAt ||
        b?.RoomCreatedAt ||
        0
    ).getTime();
    if (timestampA !== timestampB) return timestampB - timestampA;
    return (b?.RoomId || 0) - (a?.RoomId || 0);
  });
};
